import { useCapabilitiesContext } from "../shared/context";

export const useCapabilities = (): any => {

    const { can, canRoute, getFirstAccessibleRoute } = useCapabilitiesContext();

    // contractor oversight
    const isAllowedToViewContractorComparison = can("contractor_oversight:contractor_comparison:view");
    const isAllowedToViewContractorDetails = can("contractor_oversight:contractor_details:view");

    // portfolio
    const isAllowedToAddPortfolio = can("operational_delivery:portfolio_manager:portfolio:add");
    const isAllowedToEditPortfolio = can("operational_delivery:portfolio_manager:portfolio:edit");
    const isAllowedToViewPortfolioDetails = can("operational_delivery:portfolio_manager:portfolio_details:view");
    const isAllowedToViewPortfolioProjects = can("operational_delivery:portfolio_manager:portfolio_projects:view");

    // project
    const isAllowedToAddProject = can("operational_delivery:project_manager:project:add");
    const isAllowedToEditProject = can("operational_delivery:project_manager:project:edit");
    const isAllowedToViewProject = can("operational_delivery:project_manager:project:view");
    const isAllowedToPinProject = can("operational_delivery:project_manager:project:pin");

    // task
    const isAllowedToAddTask = can("operational_delivery:task_manager:task:add");
    const isAllowedToEditTask = can("operational_delivery:task_manager:task:edit");

    // jeopardy
    const isAllowedToAddJeopardyNotify = can("operational_delivery:jeopardy_manager:notify:add");
    const isAllowedToAddJeopardyReminder = can("operational_delivery:jeopardy_manager:reminder:add");
    const isAllowedToCompleteJeopardyReminder = can("operational_delivery:jeopardy_manager:reminder:complete");
    const isAllowedToMarkAsClosedJeopardy = can("operational_delivery:jeopardy_manager:mark_as_closed");
    const isAllowedToAssignAccountablePerson = can("operational_delivery:jeopardy_manager:accountable_person:assign");
    const isAllowedToCompleteToBeDone = can("operational_delivery:jeopardy_manager:to_be_done:complete");

    // queries
    const isAllowedToRaisequery = can("operational_delivery:project:query:add");
    const isAllowedToEditquery = can("operational_delivery:project:query:edit");

    const isAllowedToResolvedRaisequery = can("operational_delivery:project:query:resolve");

    // meeting
    const isAllowedToAddMeeting = can("collaboration:meetings_manager:meeting:add");
    const isAllowedToEditMeeting = can("collaboration:meetings_manager:meeting:edit");

    const isAllowedToCompleteMeeting = can("collaboration:meetings_manager:meeting:complete");

    const isAllowedToAddActionItems = can("collaboration:meetings_manager:meeting:add_action_items");
    const isAllowedToEditActionItems = can("collaboration:meetings_manager:meeting:edit_action_items");

    // document
    const isAllowedAddArtefact = can("operational_delivery:project:artefact:add");
    const isAllowedEditArtefact = can("operational_delivery:project:artefact:edit");
    const isAllowedRejectArtefact = can("operational_delivery:project:artefact:reject");
    const isAllowedReviewArtefact = can("operational_delivery:project:artefact:review");
    const isAllowedApproveArtefact = can("operational_delivery:project:artefact:approve");

    // risk
    const isAllowedToRaiseRisk = can("operational_delivery:project:risk:add");
    const isAllowedEditRisk = can("operational_delivery:project:risk:edit");

    const isAllowedAddCause = can("operational_delivery:project:risk:causes:add");
    const isAllowedEditCause = can("operational_delivery:project:risk:causes:edit");

    const isAllowedAddAssessment = can("operational_delivery:project:risk:assessment:add");
    const isAllowedEditAssessment = can("operational_delivery:project:risk:assessment:edit");

    const isAllowedAddMitigation = can("operational_delivery:project:risk:mitigation:add");
    const isAllowedEditMitigation = can("operational_delivery:project:risk:mitigation:edit");

    const isAllowedToCreateImport = can("reporting_zone:import_manager:import");
    const isAllowedToCreateReport = can("reporting_zone:custom_reports:report");

    // project sub actions

    // asset
    const isAllowedToAddAsset = can("operational_delivery:project:asset:add");
    const isAllowedToEditAsset = can("operational_delivery:project:asset:edit");

    // stakeholder
    const isAllowedToAddStakeHolder = can("operational_delivery:project:stakeholder:add");
    const isAllowedToDeleteStakeHolder = can("operational_delivery:project:stakeholder:delete");
    const isAllowedToReassignStakeHolder = can("operational_delivery:project:stakeholder:reassign")

    // approver
    const isAllowedAddApprover = can("operational_delivery:project:approval:add");
    const isAllowedEditApprover = can("operational_delivery:project:approval:edit");
    const isAllowedAddGateDecisionOwner = can("operational_delivery:project:approval:add_gate_decision_owner");

    // checklist
    const isAllowedAddChecklist = can("operational_delivery:project:checklist:add");
    const isAllowedEditChecklist = can("operational_delivery:project:checklist:edit");

    // activity
    const isAllowedToAddActivity = can("operational_delivery:project:activity:add");
    const isAllowedToEditActivity = can("operational_delivery:project:activity:edit");
    const isAllowedToDeleteActivity = can("operational_delivery:project:activity:delete");
    const isAllowedToAddActivityTodo = can("operational_delivery:project:activity:todo:add");
    const isAllowedToCompleteActivityTodo = can("operational_delivery:project:activity:todo:complete");


    // phase
    const isAllowedToAddPhase = can("operational_delivery:project:phase:add");
    const isAllowedToEditPhase = can("operational_delivery:project:phase:edit");
    const isAllowedToDeletePhase = can("operational_delivery:project:phase:delete");

    // stage gate
    const isAllowedToAddStageGate = can("operational_delivery:project:stage_gate:add");
    const isAllowedToEditStageGate = can("operational_delivery:project:stage_gate:edit");
    const isAllowedToDeleteStageGate = can("operational_delivery:project:stage_gate:delete");

    // outage window
    const isAllowedToAddOutageWindow = can("operational_delivery:project:outage_window:add");
    const isAllowedToEditOutageWindow = can("operational_delivery:project:outage_window:edit");
    const isAllowedToDeleteOutageWindow = can("operational_delivery:project:outage_window:delete");
    const isAllowedToActivateOutageWindow = can("operational_delivery:project:outage_window:activate");
    const isAllowedToDeactivateOutageWindow = can("operational_delivery:project:outage_window:deactivate");
    const isAllowedToOverrideCommissionPhaseCompletion = can("operational_delivery:project:outage_window:commission_phase_completion_override");
    
    // material request
    const isAllowedToAddMaterialRequest = can("operational_delivery:project:material_requests:add");
    const isAllowedToEditMaterialRequest = can("operational_delivery:project:material_requests:edit");
    const isAllowedToDeleteMaterialRequest = can("operational_delivery:project:material_requests:delete");

    // resource request
    const isAllowedToAddResourceRequest = can("operational_delivery:project:resource_requests:add");
    const isAllowedToEditResourceRequest = can("operational_delivery:project:resource_requests:edit");
    const isAllowedToDeleteResourceRequest = can("operational_delivery:project:resource_requests:delete");

    // invesment oversight
    const isAllowedToViewPerformanceOverview = can("investment_oversight:performance_overview:view");
    const isAllowedToViewBenefitDelivery = can("investment_oversight:benefit_delivery:view");
    const isAllowedToViewNetworkAreas = can("investment_oversight:network_areas:view");

    // commercial management
    const isAdminPerson = can("user_management:admin_person");
    const isCommercialPerson = can("user_management:commercial_person");
    const isPDEPerson = can("user_management:pde_person");
    const isDataControllerPerson = can("user_management:data_controller_person");
    const isCapDsltPerson = can("user_management:capdslt_person");
    const isContractorPerson = can("user_management:contractor_person");

    return {
        can, canRoute, getFirstAccessibleRoute,
        isAllowedToViewContractorComparison, isAllowedToViewContractorDetails, isAllowedToAddPortfolio, isAllowedToEditPortfolio, isAllowedToViewPortfolioDetails,
        isAllowedToViewPortfolioProjects, isAllowedToAddProject, isAllowedToEditProject, isAllowedToViewProject, isAllowedToPinProject, isAllowedToAddTask,
        isAllowedToEditTask, isAllowedToAddJeopardyNotify, isAllowedToAddJeopardyReminder, isAllowedToCompleteJeopardyReminder, isAllowedToMarkAsClosedJeopardy,
        isAllowedToAssignAccountablePerson, isAllowedToCompleteToBeDone, isAllowedToRaisequery, isAllowedToEditquery, isAllowedToResolvedRaisequery, isAllowedToAddMeeting,
        isAllowedToEditMeeting, isAllowedToCompleteMeeting, isAllowedToAddActionItems, isAllowedToEditActionItems, isAllowedAddArtefact, isAllowedEditArtefact,
        isAllowedApproveArtefact,isAllowedRejectArtefact,isAllowedReviewArtefact, isAllowedToRaiseRisk, isAllowedEditRisk, isAllowedAddCause, isAllowedEditCause, isAllowedAddAssessment, isAllowedEditAssessment,
        isAllowedAddMitigation, isAllowedEditMitigation, isAllowedToCreateImport, isAllowedToCreateReport, isAllowedToAddAsset, isAllowedToEditAsset, isAllowedToAddStakeHolder,
        isAllowedToDeleteStakeHolder, isAllowedToReassignStakeHolder, isAllowedAddApprover, isAllowedEditApprover, isAllowedAddGateDecisionOwner, isAllowedAddChecklist, isAllowedEditChecklist, isAllowedToAddActivity, isAllowedToEditActivity,
        isAllowedToDeleteActivity, isAllowedToAddActivityTodo, isAllowedToCompleteActivityTodo, isAllowedToAddPhase, isAllowedToEditPhase, isAllowedToDeletePhase, isAllowedToAddStageGate, isAllowedToEditStageGate,
        isAllowedToDeleteStageGate, isAllowedToAddOutageWindow, isAllowedToEditOutageWindow, isAllowedToDeleteOutageWindow, isAllowedToActivateOutageWindow, isAllowedToDeactivateOutageWindow, isAllowedToOverrideCommissionPhaseCompletion, isAllowedToAddMaterialRequest, isAllowedToEditMaterialRequest, isAllowedToDeleteMaterialRequest, isAllowedToAddResourceRequest,
        isAllowedToEditResourceRequest, isAllowedToDeleteResourceRequest, isAllowedToViewPerformanceOverview, isAllowedToViewBenefitDelivery, isAllowedToViewNetworkAreas,
        isAdminPerson, isCommercialPerson, isPDEPerson, isDataControllerPerson, isCapDsltPerson, isContractorPerson
    };

};